import { DialogSize } from '@thyme/nashville/src/types/dialogs'
import { IconSize } from '@thyme/nashville/src/types/icons'
import { SetupContext } from 'vue'

/**
 * @param _
 * @param context
 */
export default function (_: any, context: SetupContext) {
  /**
   *
   */
  function close() {
    context.emit('close')
  }

  return {
    IconSize,
    DialogSize,
    close,
  }
}
